export default __webpack_public_path__ + "static/media/goshen37.d3dcfd45.jpg";